import {createStyles, Theme, WithStyles, withStyles} from '@material-ui/core'
import React from 'react'
import {getActivityCodeById} from '../../services/code.service'

import TypographyHeader from '../Templates/TypographyHeader/TypographyHeader'

interface CodeZoneProps extends WithStyles<typeof styles> {
    activityId: string
}

interface CodeZoneState {
    code: string | null
}


class CodeZone extends React.Component<CodeZoneProps, CodeZoneState> {
    public readonly state: CodeZoneState = {
        code: null,
    }

    setCode = (code: string) => this.setState({code})

    componentDidMount() {
        getActivityCodeById(this.props.activityId)
            .then((code) => this.setCode(code))
            .catch((err) => console.log(err))
    }

    render() {
        const {classes} = this.props
        const {code} = this.state

        return (
            <div className={classes.root}>
                {code && (
                    <div style={{marginRight: '12px'}}>
                        <TypographyHeader label="Activity Code:" type={'title'} inline={true}/>
                        <span style={{marginLeft: '4px'}}/>
                        <TypographyHeader label={`${code}`} type={'title'} inline={true}/>
                    </div>
                )}
            </div>
        )
    }
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        },
    })

export default withStyles(styles)(CodeZone)
